// extracted by mini-css-extract-plugin
export default {"withoutComingSoonContainer":"styles_withoutComingSoonContainer__RfDXb","stats":"styles_stats__sBC6M","header":"styles_header__aiM4W","content":"styles_content__GNbFH"};